<div class="customer-service-banner-container">
  <cx-media [container]="csBannerMedia" removeImageTitleAttr></cx-media>
  <div class="d-flex align-self-center text">
    @if ((csBannerCaption | json) != '{}') {
    <h1>{{ csBannerCaption }}</h1>
    }
  </div>
</div>
